import { render, staticRenderFns } from "./gateway-statisics.vue?vue&type=template&id=aff47986"
import script from "./gateway-statisics.vue?vue&type=script&lang=js"
export * from "./gateway-statisics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports